export default __webpack_public_path__ + "static/media/auth-wallpaper-sa.dde17a99.png";